var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.88855 1.03344C4.85498 1.0553 4.8279 1.08656 4.81038 1.1237L3.88686 3.08636C3.82595 3.21567 3.73598 3.32751 3.62472 3.41227C3.51345 3.49703 3.38421 3.55217 3.24812 3.57293L1.1823 3.88963C1.14299 3.89546 1.10602 3.91275 1.07562 3.93954C1.04522 3.96632 1.02261 4.00152 1.01035 4.04113C0.998095 4.08074 0.996693 4.12316 1.0063 4.16357C1.01592 4.20397 1.03615 4.24073 1.06471 4.26966L2.55898 5.79524C2.65761 5.89598 2.7314 6.02036 2.77398 6.15767C2.81655 6.29499 2.82663 6.4411 2.80336 6.58341L2.45099 8.73902C2.44413 8.78 2.44838 8.82218 2.46325 8.86076C2.47812 8.89934 2.50301 8.93276 2.5351 8.95723C2.56719 8.98171 2.60518 8.99625 2.64475 8.9992C2.68433 9.00214 2.7239 8.99339 2.75896 8.97392L4.60559 7.95547C4.7273 7.88845 4.8627 7.85343 5.00016 7.85343C5.13762 7.85343 5.27302 7.88845 5.39472 7.95547L7.24176 8.97392C7.27683 8.99351 7.31645 9.00236 7.35609 8.99946C7.39573 8.99657 7.4338 8.98205 7.46595 8.95756C7.49811 8.93307 7.52305 8.89959 7.53793 8.86095C7.55281 8.82231 7.55704 8.78006 7.55013 8.73902L7.19736 6.58299C7.17419 6.44075 7.18432 6.29473 7.22689 6.1575C7.26946 6.02027 7.34319 5.89595 7.44174 5.79524L8.936 4.26924C8.96433 4.24028 8.98436 4.20358 8.99383 4.1633C9.00331 4.12302 9.00184 4.08076 8.98961 4.04131C8.97737 4.00185 8.95485 3.96678 8.9246 3.94005C8.89435 3.91331 8.85757 3.89599 8.81841 3.89005L6.7522 3.57293C6.61626 3.55201 6.4872 3.4968 6.37608 3.41205C6.26497 3.3273 6.17512 3.21554 6.11426 3.08636L5.19034 1.1237C5.17281 1.08656 5.14574 1.0553 5.11217 1.03344C5.0786 1.01158 5.03987 1 5.00036 1C4.96085 1 4.92212 1.01158 4.88855 1.03344Z",
    fill: "#6391BA",
    stroke: "#6391BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelStar);
export default __webpack_public_path__ + "static/media/level-star.b9c128896d661175b23252ea0274b34c.svg";
export { ForwardRef as ReactComponent };